import defaultValues from './defaultValues'

const focus = JSON.parse(defaultValues);

export default focus;